const extensionMapping = {
  msg: 'application/vnd.ms-outlook',
};

export default (extension) => {
  return extensionMapping[extension];
};
